import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IonModal, ModalController, ToastController } from '@ionic/angular';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { fetchAuthSession } from 'aws-amplify/auth';
import { GlobalService } from '../services/global.service';
import MainScene from '../Scenes/MainScene';
import { AudioService } from '../services/audio.service';
import { showToast } from 'src/classes/Utilities';

@Component({
  selector: 'app-audio-modal',
  templateUrl: './audio-uploader.component.html',
  styleUrls: ['./audio-uploader.component.scss'],
})
export class AudioUploaderComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  audio$ = AudioService.audio$;
  isMainScene = false;

  constructor(
    private toastController: ToastController,
    public authenticator: AuthenticatorService,
    public globalService: GlobalService,
    private modalCtrl: ModalController,
  ) { 
  }

  async ngOnInit() {
    console.log('audio-uploader.component.ts ngOnInit called');

    // Check if current scene is MainScene
    GlobalService.$activeScenes.subscribe(scenes => {
      this.isMainScene = scenes.some(scene => scene instanceof MainScene);
    });

    this.globalService.$loggedIn.subscribe({
      next: async loggedIn => {
        if(loggedIn){
          const session = await fetchAuthSession();
          const identityId = session.identityId;
          if(identityId && this.authenticator.user && this.authenticator.user.username){
            AudioService.identityId = identityId;
            AudioService.username = this.authenticator.user.username;
            AudioService.syncAudio();
          }
        }
      },
      error: async error => {
        console.error('There was an error retrieving audio data!', error);
        await showToast({message: 'There was an error retrieving your audio!', color: 'warning', duration: 2000});
      }
    })
  }

  uploadAudio() {
    console.log('uploadAudio called');
    AudioService.selectAudio();
  }

  async uploadAudioClicked() {
    if (this.isMainScene) {
      this.uploadAudio();
    } else {
      const toast = await this.toastController.create({
        message: "You can't upload audio in levels.",
        duration: 2000,
        color: 'warning',
        position: 'top',
      });
      await toast.present();
    }
  }

  cancel() {
    console.log('AudioModalComponent cancel called');

    this.modalCtrl.dismiss(null, 'cancel');
  }
}

